// Modo discreto (0.67, texto 05 D3): esconde os valores em dinheiro na tela (R$ •••) em todas as abas.
// Tocar no olhinho 👁️ (no topo das telas) mostra os valores; ao sair do app eles se escondem de novo.
// Só a TELA muda: PDFs, planilhas e relatórios gerados continuam com os valores.
import { useSyncExternalStore } from 'react';
import { aoVoltar } from './ausencia';

let ligado = false;
let revelado = false;
let versao = 0;
let simbolos: string[] = [];
const ouvintes = new Set<() => void>();
const avisar = () => { versao++; ouvintes.forEach(f => f()); };

/** Chamado pelo app quando muda o ajuste (ligado/desligado) ou a moeda. */
export function definirDiscreto(on: boolean, moedaSimbolos: string[]) {
  const s = moedaSimbolos.filter(Boolean);
  if (on === ligado && s.join('|') === simbolos.join('|')) return;
  ligado = on; simbolos = s; if (!on) revelado = false; avisar();
}
export const discretoAtivo = () => ligado && !revelado;
export const discretoLigado = () => ligado;
export function alternarRevelado() { revelado = !revelado; avisar(); }
export const useDiscreto = () => { useSyncExternalStore(cb => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; }, () => versao); return { ligado, revelado }; };
export const versaoDiscreto = () => versao;
export const ouvirDiscreto = (cb: () => void) => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; };

const esc = (x: string) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/** Troca "R$ 1.234,56" por "R$ •••" num texto da tela. */
export function mascarar(txt: string): string {
  if (!discretoAtivo() || !simbolos.length) return txt;
  let out = txt;
  for (const s of simbolos) {
    const re = new RegExp(`(-?\\s?${esc(s)}\\s?)-?[\\d.,\\u00a0\\u202f ]*\\d`, 'g');
    out = out.replace(re, (_m, pre: string) => `${pre.replace(/-/g, '').trimEnd()} •••`);
    const reDepois = new RegExp(`-?\\d[\\d.,\\u00a0\\u202f ]*\\s?${esc(s)}`, 'g');   // "1.234,56 €"
    out = out.replace(reDepois, `••• ${s}`);
  }
  return out;
}
// ao voltar para o app depois de sair, os valores se escondem de novo
aoVoltar(fora => { if (fora > 0 && revelado) { revelado = false; avisar(); } });
